export default __webpack_public_path__ + "static/menu-about-us-8cd0628b527f528ce265b266fa8c3326.png";